<rappider-form-with-guidance [editFormConfig]="editFormConfig"
                             [content]="content"
                             [errorAlertConfig]="errorAlertConfig"
                             [submitButtonLoading]="submitButtonLoading"
                             (formSubmit)="onFormSubmit($event)"></rappider-form-with-guidance>
